import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setDictionaryModalOpened } from "../../reduxSlices/dictionarySlices";
import { getProfileList, useIsMobile } from "../../store/user";
import "./dictionary.css";
import { useTranslation } from "react-i18next";

const Dictionary = ({ word, meaning = [], partsOfSpeech, onClose }) => {
  console.log("dictionary opened", word, meaning);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [inputText, setInputText] = useState("");
  const [searchedText, setSearchedText] = useState("");
  const [meanings, setMeanings] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isReading, setIsReading] = useState(false);
  const [isSpell, setIsSpell] = useState(false);
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const { t } = useTranslation();

  useEffect(() => {
    if (word) {
      setInputText(word);
      setSearchedText(word);
      setMeanings(meaning);
    }
  }, [word, meaning]);

  const readText = () => {
    speechSynthesis.cancel();
    setIsReading(true);

    const current = meanings[currentIndex];
    let fullText = "";

    if (
      current &&
      typeof current === "object" &&
      Array.isArray(current.definitions)
    ) {
      // When meanings is an array of meaning objects (from props)
      fullText = current.definitions
        .map((item, index) => `Definition ${index + 1}: ${item.definition}`)
        .join(". ");
    } else if (typeof current === "string") {
      // When meanings is a simple array of strings (from API)
      fullText = current;
    } else {
      setIsReading(false);
      return;
    }

    const speech = new SpeechSynthesisUtterance(fullText);
    speech.lang = "en-US";

    speech.onend = () => setIsReading(false);
    speech.onerror = () => setIsReading(false);

    speechSynthesis.speak(speech);
  };

  const spellText = (text) => {
    speechSynthesis.cancel();
    setIsSpell(true);
    const speech = new SpeechSynthesisUtterance(text);
    speech.onend = () => setIsSpell(false);
    speech.onerror = () => setIsSpell(false);
    speechSynthesis.speak(speech);
  };

  const handleClose = () => {
    speechSynthesis.cancel();
    onClose();
    window.parent.postMessage(
      { action: "TOGGLE_FLYOUT", isFlyoutOpen: false },
      "*",
    );
    const storedData = getProfileList();
    console.log("storeddata", storedData);
    for (let i = 0; i < storedData.length; i++) {
      if (storedData[i].title === "Reading Mask") {
        if (storedData[i].isSelected === true) {
          window.parent.postMessage("Reading Mask", "*");
        } else {
          window.parent.postMessage("unselected:Reading Mask", "*");
        }
      }
    }
  };

  const handleNext = () => {
    speechSynthesis.cancel();
    if (currentIndex < meanings.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrevious = () => {
    speechSynthesis.cancel();
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  function detectLanguage(text) {
    const germanWords = [
      "und",
      "der",
      "die",
      "das",
      "ist",
      "ein",
      "zu",
      "haben",
      "mit",
      "fÃ¼r",
      "auf",
      "nicht",
    ];
    const englishWords = [
      "the",
      "is",
      "and",
      "you",
      "have",
      "for",
      "on",
      "with",
      "not",
    ];

    let detectedLang = "en";
    const germanCount = germanWords.filter((word) =>
      text.toLowerCase().includes(word),
    ).length;
    const englishCount = englishWords.filter((word) =>
      text.toLowerCase().includes(word),
    ).length;

    if (germanCount > englishCount) detectedLang = "de";
    return detectedLang;
  }

  async function getDefinitionFromAPI(word) {
    const detectedLang = detectLanguage(word); // Detect if it's German or English
    const apiURL = `https://api.dictionaryapi.dev/api/v2/entries/${detectedLang}/${word}`;

    try {
      const response = await fetch(apiURL);
      if (!response.ok) {
        throw new Error(`API error: ${response.status}`);
      }
      const data = await response.json();
      const definition = data[0].meanings[0].definitions;
      partsOfSpeech = data[0].meanings[0].partOfSpeech;
      return definition || "Definition not found.";
    } catch (error) {
      console.error("Error fetching definition:", error);
      return "Error fetching definition.";
    }
  }

  const handleSearchInput = (e) => {
    if (e.type === "click" || e.key === "Enter") {
      setIsLoading(true);
      getDefinitionFromAPI(inputText)
        .then((definition) => {
          const extracted = definition.map((item) => item.definition);
          setMeanings(extracted);
          setSearchedText(inputText);
          setCurrentIndex(0);
          setIsLoading(false);
        })
        .catch((error) => {
          setMeanings([
            `Sorry, we couldn't find definitions for the word you were looking for. You can try the search again later or head to the web instead.`,
          ]);
          setSearchedText(inputText);
          setCurrentIndex(0);
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    window.parent.postMessage("unselected:Reading Mask", "*");
  }, []);

  window.addEventListener("message", (event) => {
    if (event.data.type === "DICTIONARY_DEFINITIONS") {
      const { word, meanings } = event.data;
      if (word.length > 0) {
        setInputText(word);
        setSearchedText(word);
        setCurrentIndex(0);
        setIsLoading(false);
      } else {
        setInputText("sample");
      }
      console.log("ðŸ“š Dictionary word:", word);
      console.log("ðŸ“– Meanings:", meanings);
    }
  });

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div
        className={`bg-white rounded-[1.188rem] text-center relative ${
          isMobile
            ? "mx-[0.80rem] pt-[1.06rem] px-[0.87rem] pb-[0.75rem]"
            : "w-[32.5rem] pt-[1.19rem] px-[0.75rem] pb-[1.875rem]"
        }`}
      >
        {/* Header */}
        <div
          className={`flex justify-between items-center ${
            isMobile ? "mb-[1.69rem]" : "mb-[1.75rem]"
          }`}
        >
          <div></div>
          <p className="dictionaryMobileTitle text-secondary font-quarternary leading-[1.375rem]">
            {t("Dictionary")}
          </p>
          <div className="cursor-pointer group" onClick={handleClose}>
            <div
              style={{ backgroundImage: `url('/dictionary/close.svg')` }}
              className="w-[1.75rem] h-[1.75rem] group-hover:hidden bg-no-repeat bg-center bg-contain"
            />
            <div
              style={{ backgroundImage: `url('/dictionary/close.svg')` }}
              className="w-[1.75rem] h-[1.75rem] hidden group-hover:block bg-no-repeat bg-center bg-contain"
            />
          </div>
        </div>

        {/* Search Box */}
        <div
          className={`${
            isMobile
              ? "py-[0.78rem] pl-[0.87rem] pr-[0.53rem] mb-[0.95rem] mx-[2.19rem]"
              : "mb-[1.375rem] mx-[2.625rem] py-[0.38rem] pl-[1.063rem] pr-[0.56rem]"
          } border border-[#E1E1E1] focus-within:border-[#3B4395] flex items-center rounded-[0.438rem]`}
        >
          <input
            type="text"
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            onKeyDown={handleSearchInput}
            className="bg-transparent w-full outline-none text-secondary"
            onFocus={() => window.parent.postMessage("Dictionary", "*")}
            onBlur={() => window.parent.postMessage("Dictionary", "*")}
          />
          <div className="cursor-pointer group" onClick={handleSearchInput}>
            {!isLoading ? (
              <>
                <div
                  style={{ backgroundImage: `url('/dictionary/search.svg')` }}
                  className="w-[2rem] h-[2rem] group-hover:hidden bg-no-repeat bg-center bg-contain"
                />
                <div
                  style={{
                    backgroundImage: `url('/dictionary/search_hover.svg')`,
                  }}
                  className="w-[2rem] h-[2rem] hidden group-hover:block bg-no-repeat bg-center bg-contain"
                />
              </>
            ) : (
              <div
                style={{
                  backgroundImage: `url('/dictionary/search_loader.svg')`,
                }}
                className="w-[2rem] h-[2rem] animate-spin bg-no-repeat bg-center bg-contain"
              />
            )}
          </div>
        </div>

        {/* Meaning Display */}
        <div className="mb-[1.375rem]">
          <p
            className={`${
              isMobile
                ? "ml-[3.25rem] mr-[2.25rem] mb-[0.94rem]"
                : "mx-[3.75rem] mb-[1.375rem]"
            } select-none font-semibold flex justify-between`}
          >
            <span className="text-tertiary font-quarternary leading-[1.375rem]">
              {searchedText} : {partsOfSpeech}
            </span>
            <span className="text-primary font-primary leading-[1.063rem] text-secondary-background">
              {currentIndex + 1} of {meanings.length}
            </span>
          </p>
          <div
            className={`flex items-center justify-between w-full ${
              isMobile
                ? "gap-[1.18rem] h-[10.125rem]"
                : "gap-[0.37rem] h-[8.125rem]"
            }`}
          >
            <button disabled={currentIndex === 0} onClick={handlePrevious}>
              <div
                style={{
                  backgroundImage: `url('/dictionary/${
                    currentIndex === 0 ? "prev_IA" : "prev_A"
                  }.svg')`,
                }}
                className="w-[2.5rem] h-[2.5rem] bg-no-repeat bg-center bg-contain"
              />
            </button>
            <div className="text-primary font-primary leading-[1.125rem] text-secondary-background w-full px-2">
              {t(meanings[currentIndex])}
            </div>
            <button
              disabled={currentIndex === meanings.length - 1}
              onClick={handleNext}
            >
              <div
                style={{
                  backgroundImage: `url('/dictionary/${
                    currentIndex === meanings.length - 1 ? "next_IA" : "next_A"
                  }.svg')`,
                }}
                className="w-[2.5rem] h-[2.5rem] bg-no-repeat bg-center bg-contain"
              />
            </button>
          </div>
        </div>

        {/* Actions */}
        <div
          className={`flex gap-[1.63rem] ${
            isMobile
              ? "justify-center flex-wrap"
              : "justify-start mx-[3.206rem]"
          }`}
        >
          <div
            onClick={() => readText()}
            className="cursor-pointer bg-read-button-background px-[1.25rem] py-[0.438rem] rounded-[0.75rem] flex items-center gap-[0.75rem]"
          >
            <div
              style={{ backgroundImage: `url('/dictionary/spell.svg')` }}
              className="w-[1.75rem] h-[1.75rem] bg-no-repeat bg-center bg-contain"
            />
            <span className="text-primary">{t("Read")}</span>
          </div>
          <div
            onClick={() => spellText(searchedText.split("").join(" "))}
            className="cursor-pointer bg-spell-button-background px-[1.25rem] py-[0.438rem] rounded-[0.75rem] flex items-center gap-[0.75rem]"
          >
            <div
              style={{ backgroundImage: `url('/dictionary/read.svg')` }}
              className="w-[1.75rem] h-[1.75rem] bg-no-repeat bg-center bg-contain"
            />
            <span className="text-primary">{t("Spell")}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dictionary;

